import { formatNumberTo } from "../../utils/index";
import BaseLineChart from "../BaseLineChart";

const CbsaCancerLineChart = (data) => {
  const chartData = [
    {
      name: "2025",
      value: Math.round(data.data["2025"]) ? Math.round(data.data["2025"]) : 0,
    },
    {
      name: "2030",
      value: Math.round(data.data["2030"]) ? Math.round(data.data["2030"]) : 0,
    },
    {
      name: "2035",
      value: Math.round(data.data["2035"]) ? Math.round(data.data["2035"]) : 0,
    },
  ];

  return (
    <BaseLineChart
      data={chartData}
      tooltipFormatter={(value) => formatNumberTo(value)}
    />
  );
};

export default CbsaCancerLineChart;
